import React from 'react';

const PodContext = React.createContext({
  isReady: false,
  users: null,
  selectedPodId: null,
  pods: [],
  assistantCoaches: [],
  coachInternalAssignments: [],
});

export default PodContext;
